// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"c4745d4f","266":"c4745d4f","501":"c4745d4f"}[chunkId] + ".chunk.css";
};